import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { IonicModule } from '@ionic/angular';
import { UIModule } from 'src/app/ui/ui.module';
import { TranslocoRootModule } from 'src/app/core/translation/transloco-root.module';
import { CommonModule } from '@angular/common';
import { SpinnersComponent } from './spinners.component';

@NgModule({
  imports: [CommonModule, FormsModule, IonicModule, UIModule, TranslocoRootModule],
  declarations: [SpinnersComponent],
})
export class SpinnersModule {}
